import api from 'api';

export const mutateActivity = async ({ data, id }) => {
  const endpoint = `/activities${id ? `/${id}` : ''}`;

  return api()[id ? 'put' : 'post'](endpoint, data);
};

export const deleteActivity = async (id: number) => api().delete(`/activities/${id}`);

export const updateDocument = async (id, document) => api().post(`/activities/documents/${id}`, { document });
